import React from "react"
import ContactForm from "./ContactForm"

export default function ContactTab (){
    return (
        <ContactForm/>
    )  
}